import React, { FC } from 'react';
import * as S from './Menu.style';

interface MenuItem {
  label: string;
  handler?: () => void;
  image?: string;
}

interface IProps {
  items: MenuItem[];
}

export const Menu: FC<IProps> = ({ items }) => {
  return (
    <>
      <S.Placeholder />
      <S.Container>
        {items.map(({ label, image, handler }, index) => (
          <S.Item key={index} onClick={handler}>
            {image && <img src={image} alt={label} />}
            <div>{label}</div>
          </S.Item>
        ))}
      </S.Container>
    </>
  );
};
